import React from 'react'
import ArtistForm from './components/ArtistForm'

const FormView = () => {
  return (
    <>
      <div className='flex flex-wrap flex-1 min-h-full'>
        <div className='p-6 flex-1'>
          <ArtistForm />
        </div>
      </div>
    </>
  )
}

export default FormView
